import * as Yup from "yup";

export const userSchema = Yup.object().shape({
  username: Yup.string().required(),
  email: Yup.string().email().required(),
  phoneCode: Yup.string().required(),
  phone: Yup.string().min(7).required(),
  referral_code: Yup.string().required(),
  password: Yup.string()
    .required()
    .min(4)
    .matches(RegExp("(.*[a-z].*)"), "Lowercase")
    .matches(RegExp("(.*[A-Z].*)"), "Uppercase")
    .matches(RegExp("(.*\\d.*)"), "Number")
    .matches(RegExp('[!@#$%^&*(),.?":{}|<>]'), "Special"),
});
